import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { authInterceptorniOrnat } from './authInterceptor';

// Sessiya yaroqsiz bo'lib qolsa foydalanuvchi darhol login sahifasiga qaytadi.
authInterceptorniOrnat();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);